import cx from 'classnames';
import { ReactNode } from 'react';

import { IconButton } from '../form/button/IconButton';
import { IconChevronLeft } from '../icons/ChevronLeft';
import { IconChevronRight } from '../icons/ChevronRight';
import { IconCross } from '../icons/Cross';

import { useWemap } from './hooks/useWemap';
import style from './WemapDrawer.module.css';

export type WemapDrawerProps = {
    children: ReactNode;
    isClosable: boolean;
    isCollapsable: boolean;
    onClose: () => void;
    onCollapse: () => void;
    onExpand: () => void;
};

export function WemapDrawer({
    children,
    isClosable,
    isCollapsable,
    onClose,
    onCollapse,
    onExpand,
}: WemapDrawerProps) {
    const { isDrawerExpanded, setIsDrawerExpanded } = useWemap();

    function handleCloseClick() {
        onClose();
    }

    function handleToggleDrawerCollapseClick() {
        setIsDrawerExpanded((previousIsDrawerExpanded) => {
            if (previousIsDrawerExpanded) {
                onCollapse();
            } else {
                onExpand();
            }
            return !previousIsDrawerExpanded;
        });
    }

    return (
        <div
            className={cx(style.drawer, {
                [style.drawerCollapsed]: isCollapsable && !isDrawerExpanded,
            })}
        >
            {children}

            {isClosable ? (
                <IconButton
                    Icon={IconCross}
                    size="M"
                    onClick={handleCloseClick}
                    className={style.closeButton}
                />
            ) : null}

            {isCollapsable ? (
                <IconButton
                    className={style.toggleDrawerButtonCollapse}
                    Icon={isDrawerExpanded ? IconChevronLeft : IconChevronRight}
                    onClick={handleToggleDrawerCollapseClick}
                />
            ) : null}
        </div>
    );
}

WemapDrawer.WIDTH = 400;
